import React from 'react';

interface UpdatedCustomIconProps {
  filled?: boolean;
  width?: string;
}

const LogoSquare: React.FC<UpdatedCustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '49'}
    height={width ?? '49'}
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_434_14933)'>
      <path
        d='M0.580078 0.168246L6.1697 5.24748L13.5157 5.27716L17.2892 0.0664062L0.580078 0.168246Z'
        fill='#979797'
      />
      <path
        d='M0.57373 0.164062V22.331L6.16336 5.24328L0.57373 0.164062Z'
        fill='#EFEFEF'
      />
      <path
        d='M6.16336 5.24609L13.5093 5.27578L0.57373 22.3338L6.16336 5.24609Z'
        fill='white'
      />
      <path
        d='M22.1763 5.25029L26.6505 0.230469H39.616L28.7018 5.27998L22.1763 5.25029Z'
        fill='#979797'
      />
      <path
        d='M22.1766 5.24609L28.702 5.27578L7.36919 30.986L0.694092 31.0665L22.1766 5.24609Z'
        fill='#B2B2B2'
      />
      <path
        d='M0.699846 31.0688L7.37494 30.9883L0.627197 47.7493L0.699846 31.0688Z'
        fill='#EFEFEF'
      />
      <path
        d='M7.37494 30.9901L28.7078 5.27998L39.6221 0.230469L0.627197 47.7509L7.37494 30.9901Z'
        fill='white'
      />
      <path
        d='M9.44678 47.6418L20.6474 42.0622L42.1554 16.4964L48.5487 0.0664062L9.44678 47.6418Z'
        fill='#979797'
      />
      <path
        d='M20.6474 42.0586L27.1344 42.4746L22.5619 47.6174L9.44678 47.6385L20.6474 42.0586Z'
        fill='#EFEFEF'
      />
      <path
        d='M48.5454 0.0664062L42.1521 16.4964H48.6434L48.5454 0.0664062Z'
        fill='#EFEFEF'
      />
      <path
        d='M42.1509 16.4961H48.6422L27.1299 42.4777L20.6428 42.0621L42.1509 16.4961Z'
        fill='white'
      />
      <path
        d='M35.8501 42.3353H42.8889L48.4655 25.5703L35.8501 42.3353Z'
        fill='#979797'
      />
      <path
        d='M35.849 42.3359H42.8871L48.5667 47.7419L31.8191 47.7205L35.849 42.3359Z'
        fill='#EFEFEF'
      />
      <path
        d='M48.4649 25.5742L48.5675 47.7455L42.8879 42.3392L48.4649 25.5742Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_434_14933'>
        <rect width='48' height='48' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export default LogoSquare;
